export * from './useWaitingRoomSeo';
